/* @flow */

import React from 'react'
import ReactDOM from 'react-dom'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { withBreakpoints } from 'react-breakpoints'
import { FaHome, FaSearch } from 'react-icons/fa'
import { FiX, FiChevronDown, FiChevronUp } from 'react-icons/fi'

import {
  PermissionContext,
  UserHasPermissions,
} from '../../../../infrastructure/components/Authorization'
import MobileNavigation from '../../../../infrastructure/components/Mobile/MobileNavigation'
import { changeWebshopCurrency } from '../../../shop/actions/index'
import {
  changeBrandContext,
  getAvailableBrands,
} from '../../../brands/actions/index'
import { refreshSession } from '../../../../infrastructure/actions/session'
import { regainAdmin } from '../../../admin/actions'
import AppContext from '../../../app-store/components/AppContext'

import { FakeLinkStyle, SplitComponent } from '../../../shared'
import SearchBar from '../../components/SearchBar'
import { openNavigationSearch } from '../../actions/search'
import NavigationRightSide from './NavigationRightSide'
import Notifications from './Notifications'
import { Submenu, SubmenuNavigationLink } from './shared'

const TopNavigation = props => {
  const {
    adminEmail,
    createNavigationLinks,
    currentBreakpoint,
    customer,
    entity,
    settings,
    toggleSpotlight,
    user,
  } = props

  const useNewColors = user.feature_flags.new_colors

  const [showMobileNavBar, setShowMobileNavBar] = React.useState(false)
  const [expandedMobileHeader, setExpandedMobileHeader] = React.useState(false)

  const toggleMobileNavigationSubItems = React.useCallback(
    key => {
      setExpandedMobileHeader(s => (s === key ? false : key))
    },
    [setExpandedMobileHeader]
  )

  const toggleMobileNavBar = React.useCallback(() => {
    setShowMobileNavBar(s => !s)
  }, [setShowMobileNavBar])

  const toggleSearch = React.useCallback(() => {
    if (toggleSpotlight) {
      toggleSpotlight()
    }
  }, [toggleSpotlight])

  const onHideMobileNavigation = React.useCallback(() => {
    setShowMobileNavBar(false)
  }, [setShowMobileNavBar])

  const navigationItems = React.useMemo(() => {
    const navigationItems = createNavigationLinks({
      customer,
      entity,
      onHideMobileNavigation,
      toggleSearch,
      user,
      useNewColors,
    })

    const isAdmin = user.user_type === 'admin'
    const isAgent = user.user_type === 'agent'

    const mappedNavigationItems = navigationItems
      .map(item => {
        if (item.admin === true && !isAdmin) {
          return null
        }

        if (item.custom_check) {
          if (!item.custom_check({ entity, customer })) {
            return null
          }
        }

        if (item.freemium !== undefined) {
          if (item.freemium !== entity.freemium) {
            return null
          }
        }

        if (item.agent !== undefined) {
          if (item.agent !== isAgent) {
            return null
          }
        }

        if (
          item.permission_not &&
          !!UserHasPermissions(user, item.permission_not)
        ) {
          return null
        }

        const copy = { ...item }

        if (copy.sub_items) {
          copy.sub_items = copy.sub_items
            .map(subItem => {
              if (subItem.admin === true && !isAdmin) {
                return null
              }

              if (subItem.custom_check) {
                if (!subItem.custom_check({ entity, customer })) {
                  return null
                }
              }

              if (subItem.freemium !== undefined) {
                if (subItem.freemium !== entity.freemium) {
                  return null
                }
              }

              if (subItem.agent !== undefined) {
                if (subItem.agent !== isAgent) {
                  return null
                }
              }

              if (
                subItem.permission_not &&
                !!UserHasPermissions(user, subItem.permission_not)
              ) {
                return null
              }

              return subItem
            })
            .filter(subItem => subItem)
        }

        return copy
      })
      .filter(item => item)

    return mappedNavigationItems
  }, [
    customer,
    entity,
    onHideMobileNavigation,
    toggleSearch,
    user,
    useNewColors,
  ])

  const entityType = entity.entity_type

  const apps = entity.apps.map(a => a.app)

  const isMobile = currentBreakpoint === 'mobile'
  const isHacked = false //adminEmail === 'mk@traede.com'

  return (
    <NavigationContainer>
      <MainNavigationContainer useNewColors={useNewColors}>
        {isMobile && (
          <>
            <MobileNavigationHeader>
              <MobileNavigationToggle onClick={toggleMobileNavBar}>
                <span className="glyphicon glyphicon-menu-hamburger" />
              </MobileNavigationToggle>
            </MobileNavigationHeader>

            {/* currently we do not render mobile nav bar at all if it does not show,
            since the fixed overlay breaks links in order lists etc */}
            {showMobileNavBar && (
              <MobileNavigation
                header={
                  <>
                    <div>NAVIGATION</div>

                    <div
                      className="close"
                      onClick={() => setShowMobileNavBar(false)}
                    >
                      <FiX size={16} style={{ verticalAlign: 'middle' }} />
                    </div>
                  </>
                }
                headerStyle={{ height: 50 }}
                onHide={() => setShowMobileNavBar(false)}
                show={showMobileNavBar}
                wrapperClass="normal-scroll"
              >
                <MobileNavigation.ItemList>
                  {navigationItems.map(item => {
                    const subItems = item.sub_items || []

                    const content = (
                      <li key={item.key}>
                        {item.link && subItems.length == 0 && (
                          <Link to={item.link} onClick={onHideMobileNavigation}>
                            {item.mobile_label || item.label}
                          </Link>
                        )}
                        {item.link && subItems.length > 0 && (
                          <MobileNavigation.ItemListHeader
                            onClick={() =>
                              toggleMobileNavigationSubItems(item.key)
                            }
                            style={{ alignItems: 'center', display: 'flex' }}
                          >
                            <div style={{ flex: 1 }}>
                              {item.mobile_label || item.label}
                            </div>

                            {expandedMobileHeader == item.key && (
                              <FiChevronDown size={14} />
                            )}
                            {expandedMobileHeader != item.key && (
                              <FiChevronUp size={14} />
                            )}
                          </MobileNavigation.ItemListHeader>
                        )}
                        {!item.link &&
                          item.render_mobile &&
                          item.render_mobile({
                            toggleSearch,
                          })}
                      </li>
                    )

                    const wrapped = wrapInFeatureFlag(
                      wrapInPermission(wrapInAppContext(content, item), item),
                      item
                    )

                    return (
                      <>
                        {wrapped}

                        {expandedMobileHeader == item.key && (
                          <MobileNavigation.SubItemList>
                            {subItems.map(subItem => {
                              const innerContent = (
                                <li key={subItem.key}>
                                  <Link
                                    to={subItem.link}
                                    onClick={onHideMobileNavigation}
                                  >
                                    {subItem.mobile_label || subItem.label}
                                  </Link>
                                </li>
                              )

                              return wrapInFeatureFlag(
                                wrapInPermission(
                                  wrapInAppContext(innerContent, subItem),
                                  subItem
                                ),
                                subItem
                              )
                            })}
                          </MobileNavigation.SubItemList>
                        )}
                      </>
                    )
                  })}
                </MobileNavigation.ItemList>
              </MobileNavigation>
            )}
          </>
        )}

        {!isMobile && (
          <DesktopNavigationLeftSide>
            {navigationItems.map(item => {
              let content

              // icon only
              if (!item.label) {
                content = (
                  <MainNavigationIconOnlyContainer
                    useNewColors={useNewColors}
                    key={item.key}
                  >
                    {item.link && (
                      <NavigationItemLink
                        to={item.link}
                        useNewColors={useNewColors}
                      >
                        <span
                          className={item.icon}
                          style={{ paddingRight: 0 }}
                          tabIndex="-1"
                        />
                      </NavigationItemLink>
                    )}
                    {!item.link &&
                      item.render &&
                      item.render({
                        toggleSearch,
                      })}
                  </MainNavigationIconOnlyContainer>
                )

                // icon + label
              } else {
                content = (
                  <NavigationItem
                    key={item.key}
                    link={item.link}
                    icon={item.icon}
                    label={item.label}
                    permission={item.permission}
                    useNewColors={useNewColors}
                  >
                    {(item.sub_items || []).map(subItem => {
                      const subItemRender = (
                        <SubmenuNavigationItem
                          link={subItem.link}
                          label={subItem.label}
                          permission={subItem.permission}
                          newLabel={subItem.new_label}
                        />
                      )

                      return wrapInFeatureFlag(
                        wrapInPermission(
                          wrapInAppContext(subItemRender, subItem),
                          subItem
                        ),
                        subItem
                      )
                    })}
                  </NavigationItem>
                )
              }

              return wrapInFeatureFlag(
                wrapInPermission(wrapInAppContext(content, item), item),
                item
              )
            })}
          </DesktopNavigationLeftSide>
        )}
        <NavigationRightSide
          useNewColors={useNewColors}
          type="main"
          {...props}
        />
      </MainNavigationContainer>
    </NavigationContainer>
  )
}

const TopNavigationWithBreakpoints = withBreakpoints(TopNavigation)

export default TopNavigationWithBreakpoints

const NavigationContainer = styled.div`
  position: fixed;
  z-index: 1;
  width: 100%;

  @media print {
    display: none;
  }
`

const MainNavigationContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${({ useNewColors }) => {
    return useNewColors
      ? css`
          background: #262626;
          height: 50px;
          font-size: 12px;
        `
      : css`
          background: #385567;
          height: 62px;
        `
  }}
`

const DesktopNavigationLeftSide = styled.div`
  display: flex;
  flex: 1;
`

const MobileNavigationHeader = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  padding: 0 15px;
`

const MobileNavigationToggle = styled.button.attrs({
  type: 'button',
})`
  background: transparent;
  border: 1px solid white;
  border-radius: 5px;
  color: #ccc;
  font-size: 20px;
  padding: 5px 15px;
  outline: 0;
`

type NavigationItemProps = {
  children?: React.Node,
  label: string,
  link: string,
  icon?: string,
  isSubmenu?: boolean,
  permission?: string | Array<string>,
  subtitle?: string,
}

const NavigationItem = (props: NavigationItemProps) => {
  const {
    children,
    customIcon,
    permission,
    link,
    icon,
    label,
    subtitle,
    useNewColors,
  } = props

  return (
    <PermissionContext permission={permission}>
      <MainNavigationItemContainer
        className={children && children.length ? 'dropdown' : ''}
        useNewColors={useNewColors}
      >
        <NavigationItemLink
          to={link}
          activeClassName="active"
          tabIndex="-1"
          useNewColors={useNewColors}
        >
          {icon && <span className={'lnr lnr-' + icon} />}
          {customIcon && customIcon}
          <NavigationItemTitle useNewColors={useNewColors}>
            <div>{label}</div>
            <NavigationItemSubtitle useNewColors={useNewColors}>
              {subtitle}
            </NavigationItemSubtitle>
          </NavigationItemTitle>
        </NavigationItemLink>
        {children && children.length ? <Submenu>{children}</Submenu> : null}
      </MainNavigationItemContainer>
    </PermissionContext>
  )
}

const SubmenuNavigationItem = ({
  icon,
  label,
  link,
  permission,
  newLabel,
}: NavigationItemProps) => {
  return (
    <SubmenuNavigationItemContainer>
      <PermissionContext permission={permission}>
        <SubmenuNavigationLink
          className="clearfix"
          to={link}
          activeClassName="active"
          tabIndex="-1"
        >
          {label}

          {newLabel && <NewLabel>NEW</NewLabel>}
        </SubmenuNavigationLink>
      </PermissionContext>
    </SubmenuNavigationItemContainer>
  )
}

const NavigationItemLink = styled(Link)``

export const NavigationLinkCss = css`
  align-items: center;
  color: white;
  display: flex;
  padding: 0 14px;
  height: ${({ useNewColors }) => (useNewColors ? '50px' : '62px')};
  white-space: nowrap;
  overflow-wrap: break-word;

  &:hover {
    color: white;
    background: ${({ useNewColors }) => (useNewColors ? '#000' : '#344854')};
  }
`

const NewLabel = styled.span`
  background-color: #e1e7ea;
  border-radius: 2px;
  color: #8fa0ad;
  margin-left: 5px;
  font-size: 10px;
  padding: 2px 4px;
  text-transform: uppercase;
`

const MainNavigationBaseItemContainer = styled.div`
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;

  &.dropdown:hover > ${Submenu} {
    display: block;
  }

  > ${NavigationItemLink} {
    ${NavigationLinkCss};
  }
`

const MainNavigationIconOnlyContainer = styled(MainNavigationBaseItemContainer)`
  > ${NavigationItemLink} {
    font-size: ${({ useNewColors }) => (useNewColors ? '14px' : '18px')};
  }
`

const MainNavigationItemContainer = styled(MainNavigationBaseItemContainer)`
  .lnr {
    ${({ useNewColors }) => {
      return useNewColors
        ? css`
            font-size: 14px;
            margin-right: 5px;
          `
        : css`
            font-size: 16px;
            margin-right: 7px;
          `
    }};
  }

  @media (max-width: 1500px) {
    .lnr {
      display: none;
    }
  }
`

const SubmenuNavigationItemContainer = styled.div`
  > ${NavigationItemLink} {
  }
`

const NavigationItemSubtitle = styled.div``

const NavigationItemTitle = styled.div`
  position: relative;

  > ${NavigationItemSubtitle} {
    color: #e2e2e2;
    font-size: 10px;
    position: absolute;
    top: 85%;
  }
`

const wrapInFeatureFlag = (innerRender, item) => {
  if (!item.feature_flag) {
    return innerRender
  }

  return (
    <SplitComponent
      entityOrUser
      splitKey={item.feature_flag}
      not={item.feature_flag_not}
      true={innerRender}
    />
  )
}

const wrapInPermission = (innerRender, item) => {
  if (!item.permission) {
    return innerRender
  }

  return (
    <PermissionContext permission={item.permission}>
      {innerRender}
    </PermissionContext>
  )
}

const wrapInAppContext = (innerRender, item) => {
  if (!item.app) {
    return innerRender
  }

  return (
    <AppContext app={item.app} not={item.app_not}>
      {innerRender}
    </AppContext>
  )
}
